var baseUnits = {
  rootSizeUnit: 16,
  rootSizeUnitMobile: 14,
  rootSpacingUnit: 4,
  rootRhythmUnit: 8
};
export default baseUnits;